module.exports = __webpack_public_path__ + "static/media/9DESA32.ea110493.jpg";